import { Component, ViewChild, AfterViewInit } from '@angular/core';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { BaseModalComponent } from '../../base-modal/base-modal.component';
import { UsbBaseModalComponent } from '../../usb-base-modal/usb-base-modal.component';
import { NotificationService } from 'app/shared/notifications/notification.service';

@Component({
  selector: 'usb-not-found-modal',
  templateUrl: './not-found-modal.component.html',
  styleUrls: ['./not-found-modal.component.scss']
})
export class NotFoundModalComponent extends BaseModalComponent implements AfterViewInit {
  public icon: string = '';
  public iconClass: string = '';
  public iconColor: string = '';
  public titleReverse: boolean = false;

  @ViewChild(UsbBaseModalComponent) usbBaseModal: UsbBaseModalComponent;

  constructor(
    public bsModalRef: BsModalRef,
    private notificationService: NotificationService
  ) {
    super();
  }

  ngAfterViewInit(): void {
    // Forward events from UsbBaseModalComponent to this component's confirmResult
    if (this.usbBaseModal) {
      this.usbBaseModal.confirmResult.subscribe((result: boolean) => {
        this.confirmResult.next(result);
      });
    }
  }

  copySearch(): void {
    const payloadStr = localStorage.getItem('payload');
    if (payloadStr) {
      try {
        const payload = JSON.parse(payloadStr);
        const formattedBody = JSON.stringify(payload, null, 2);
        navigator.clipboard.writeText(formattedBody).then(() => {
          this.notificationService.success('Búsqueda copiada al portapapeles');
        }).catch(() => {
          this.notificationService.error('Error al copiar la búsqueda');
        });
      } catch (e) {
        this.notificationService.error('Error al procesar la búsqueda');
      }
    } else {
      this.notificationService.warning('No se encontró información de búsqueda');
    }
  }

  protected onInit(): void {
    // Not-found-specific initialization if needed
  }
}
